module.exports = __webpack_public_path__ + "img/full4-min.7d793e78.png";